
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 36 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#default-app-logo_svg__clip0)","fill":"#D6DBE6"}},[_c('path',{attrs:{"d":"M.58 23.806c0-1.603 1.3-2.903 2.904-2.903h8.71c1.603 0 2.903 1.3 2.903 2.904v8.71c0 1.603-1.3 2.902-2.903 2.902h-8.71a2.903 2.903 0 01-2.903-2.903v-8.71zM.58 4.645c0-1.603 1.3-2.903 2.904-2.903h8.71c1.603 0 2.903 1.3 2.903 2.903v8.71c0 1.603-1.3 2.903-2.903 2.903h-8.71a2.903 2.903 0 01-2.903-2.903v-8.71zM18.789 11.053a2.903 2.903 0 010-4.106L24.947.788a2.903 2.903 0 014.106 0l6.159 6.16a2.903 2.903 0 010 4.105l-6.159 6.159a2.903 2.903 0 01-4.106 0l-6.158-6.16zM19.742 23.806c0-1.603 1.3-2.903 2.903-2.903h8.71c1.603 0 2.903 1.3 2.903 2.904v8.71c0 1.603-1.3 2.902-2.903 2.902h-8.71a2.903 2.903 0 01-2.903-2.903v-8.71z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"default-app-logo_svg__clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h36v36H0z"}})])])])
          )
        }
      }
    